import { useLayout } from 'context'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import * as controllers from 'controllers'
import { ArrowBack } from '@mui/icons-material'
import { Grid, Card, CardContent, Typography, Button } from '@mui/material'
import { VehicleNeedsInHouseAdditionalProgrammingDetailsDto } from 'dtos'
import { enqueueSnackbar } from 'notistack'
import VehicleNeedsInHouseAdditionalProgrammingHeroCard from './VehicleNeedsInHouseAdditionalProgrammingHeroCard'
import Step1StartAdditionalProgramming from './Step1StartAdditionalProgramming'

export default function NeedsInHouseAdditionalProgramming() {
  const { vehicleGuid } = useParams()
  const layout = useLayout()
  const navigate = useNavigate()

  const [initialValues, setInitialValues] = useState<VehicleNeedsInHouseAdditionalProgrammingDetailsDto>(
    new VehicleNeedsInHouseAdditionalProgrammingDetailsDto()
  )

  const [activeStep] = useState<number>(0)

  useEffect(() => {
    if (vehicleGuid) {
      layout.setIsLayoutLoading(true)
      controllers
        .getNeedsInHouseAdditionalProgrammingDetails(vehicleGuid)
        .then(response => {
          setInitialValues(response.value)
        })
        .finally(() => {
          layout.setIsLayoutLoading(false)
        })
    }
  }, [vehicleGuid])

  const isAdditionalProgrammingStarted = Boolean(initialValues?.additionalProgrammingInHouseStarted)
  const successMessage = isAdditionalProgrammingStarted
    ? 'Additional Programming In-House Completed Successfully!'
    : 'Additional Programming In-House Started Successfully!'

  return (
    <Grid container spacing={1} alignItems='center'>
      <Grid item xs={12}>
        <Card>
          <CardContent>
            <Grid container justifyContent='space-between'>
              <Grid item>
                <Typography fontWeight='bold' variant='h5' sx={{ pr: 1 }}>
                  Needs In-House Additional Programming
                </Typography>
              </Grid>

              <Grid item xs={12} sm='auto' container spacing={2} alignItems='center' justifyContent='flex-end'>
                <Grid item>
                  <Button
                    onClick={() => {
                      navigate('/to-do-list')
                    }}
                    color='primary'
                    startIcon={<ArrowBack />}
                    variant='text'
                  >
                    BACK
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12}>
        <VehicleNeedsInHouseAdditionalProgrammingHeroCard vehicle={initialValues} />
      </Grid>

      {activeStep === 0 && (
        <Grid item xs={12}>
          <Step1StartAdditionalProgramming
            needsInHouseAdditionalProgrammingDetails={initialValues}
            onNext={() => {
              layout.setIsLayoutLoading(true)
              controllers
                .updateNeedsInHouseAdditionalProgrammingDetails(vehicleGuid!, {
                  ...initialValues
                })
                .then(response => {
                  enqueueSnackbar(successMessage, { variant: 'success' })
                  setInitialValues(response.value)
                  navigate('/to-do-list', { replace: true })
                })
                .finally(() => {
                  layout.setIsLayoutLoading(false)
                })
            }}
            vehicle={initialValues}
            vehicleGuid={vehicleGuid}
          />
        </Grid>
      )}
    </Grid>
  )
}
